import { api } from '../../lib/api';
import { dateTime } from '../../lib/format';
import { useLoad } from '../../lib/hooks';
import type { ActivityEntry, Project } from '../../lib/types';
import { Icon } from '../../components/Icon';
import { Empty, ErrorState, Spinner } from '../../components/ui';

/** Audit trail: who signed in (and from where), who said, changed or uploaded what. */
export function ActivityTab({ project }: { project: Project }) {
  const { data, loading, error, reload } = useLoad(() => api.get<{ activity: ActivityEntry[] }>(`/api/projects/${project.id}/activity?limit=300`), [project.id]);

  if (loading && !data) return <Spinner label="Loading activity" />;
  if (error) return <ErrorState message={error} onRetry={() => reload()} />;
  const entries = data?.activity ?? [];
  if (entries.length === 0) return <Empty icon="activity" title="No activity yet" />;

  return (
    <div className="stack" style={{ gap: 12 }}>
      <div className="row-between">
        <p className="muted">Sign-ins, revisions, uploads and changes on this project. Newest first.</p>
        <button className="btn btn-ghost btn-sm" onClick={() => reload(true)}>
          <Icon name="refresh" /> Refresh
        </button>
      </div>
      <div className="card card-pad activity-list">
        {entries.map((entry) => (
          <div key={entry.id} className="activity-row">
            <span className="muted" style={{ whiteSpace: 'nowrap' }}>
              {dateTime(entry.createdAt)}
            </span>
            <span>
              <strong>{entry.actorName || 'System'}</strong> <span className="muted">·</span> {entry.summary || entry.action}
            </span>
            <span className="mono muted">{entry.ip || ''}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
